var _this = this;
import React from 'react';
import { Modal, CustomModalLayout } from 'wix-style-react';
var NewAppSettingsModal = function (props) {
    var settingsUrl = props.settingsUrl, closeModal = props.closeModal;
    var handleMessage = function (msg) {
        if (msg.data.type === 'APP_INSTALLATION_FINISHED' ||
            msg.data.type === 'CONSENT_USER_CANCELED' ||
            msg.data.type === 'FINISH_INSTALLATION_EMBEDDED') {
            closeModal();
        }
    };
    React.useEffect(function () {
        return window.addEventListener('message', function (msg) {
            handleMessage(msg);
            return function () { return window.removeEventListener('message', _this.handleMessage); };
        });
    }, []);
    return (React.createElement(Modal, { isOpen: true },
        React.createElement(CustomModalLayout, { onCloseButtonClick: closeModal, removeContentPadding: true, width: '600px' },
            React.createElement("iframe", { src: settingsUrl, width: "100%", height: "463px", frameBorder: "0" }))));
};
export default NewAppSettingsModal;
//# sourceMappingURL=new-app-settings-modal.js.map